<template>
  <div v-show="!stepContext.loading" class="oail-Layout">
    <div class="oail-Layout_Nav">
      <AppLogo height="24" width="126" />

      <div class="oail-Layout_StepperWrap">
        <OnboardingAiStepper
          v-if="!stepContext.hideStepper && !stepContext.loading"
          :current-step="stepContext.currentStep"
          :total-count="stepContext.totalCount"
          class="oail-Layout_Stepper"
        />
      </div>
    </div>

    <div class="oail-Layout_Main">
      <slot />
    </div>
  </div>
  <OboardLogoLoader v-if="stepContext.loading" />
</template>

<script setup>
import { provideOnboardingAiStepContext } from '@/composables/onboarding-ai-step'

import AppLogo from '@/components/AppLogo'
import OnboardingAiStepper from '@/components/ui/onboarding-ai/OnboardingAiStepper'
import OboardLogoLoader from '@/components/ui/SkeletonLoaders/OboardLogoLoader'

defineOptions({
  name: 'OnboardingAiLayout'
})

const stepContext = provideOnboardingAiStepContext()
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/onboarding-ai-step';

.oail-Layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: $oai-global-bg;
}

.oail-Layout_Nav {
  align-items: center;
  gap: 24px;
  height: $oai-step-header-height;
  padding: 12px 24px;
  border-bottom: 1px solid $grey-2-next;
  background: $white;

  display: grid;
  grid-template-columns: 1fr auto 1fr;
}

.oail-Layout_StepperWrap {
  display: flex;
  flex: 1;
  justify-content: center;
}

.oail-Layout_Stepper {
  width: 100%;
}

.oail-Layout_Main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
